import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";

function Active_Member() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  let user = "";
  //   let income = 10

  const [isLoading, setisLoading] = useState(false);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);

  const [search, setSearch] = useState(user);

  const [positionfilter, setpositionfilter] = useState("0");
  const [StatusFilter, setStatusFilter] = useState("2");

  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");
  const [TotalAmount1, setTotalAmount1] = useState(0);
  const [TotalCount1, setTotalCount1] = useState(0);

  let arrayLeft = [];
  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/ActiveMemberList",
        {
          loginid: userId,
          uid: search,
          fdate: formdate,
          tdate: todate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("ActiveMemberList_New-->", responceRight.data.data[0]);
      responceRight = responceRight.data.data[0];
      setleftreferralApi([]);
      let TotalAmount = 0;
      let TotalCount = 0;
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: `${item?.row}`,
          id: `${item?.uid} `,
          // Position: item?.user_id?.substring(0, 4) + "..." + item?.user_id?.substring(item?.user_id?.length - 4),
          sponser_id: item?.sid,
          password: item?.password,
          packageamount: `${item?.packageamount}`,
          date_time: `${item?.ee} `,
          // status: `${item?.idtypes} `,
          top_updates: `${item?.dd} `,
          blockstatus: `${item?.blockstatus} `,
          staking: `${item?.blockbtn}`,
          //   txn: `${item?.txn} `,
        });
        TotalAmount = parseFloat(TotalAmount) + parseFloat(item.pp);
        TotalCount = parseInt(TotalCount) + parseInt(1);
        setleftreferralApi(arrayLeft);
      });

      setTotalAmount1(TotalAmount);
      setTotalCount1(TotalCount);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, [positionfilter, StatusFilter]);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/ActiveMemberList",
        {
          loginid: userId,
          uid: search,
          fdate: formdate,
          tdate: todate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("ActiveMemberList_New-->", responceRight.data.data[0]);
      responceRight = responceRight.data.data[0];
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: `${item?.row}`,
          id: `${item?.uid} `,
          // Position: item?.user_id?.substring(0, 4) + "..." + item?.user_id?.substring(item?.user_id?.length - 4),
          sponser_id: item?.sid,
          password: item?.password,
          packageamount: `${item?.pp}`,
          date_time: `${item?.ee} `,
          // status: `${item?.idtypes} `,
          top_updates: `${item?.dd} `,
          blockstatus: `${item?.blockstatus} `,
          staking: `${item?.blockbtn}`,
          //   txn: `${item?.txn} `,
        });
      });

      const fileName = "ActivemembersRecord";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User ID", accessor: "id" },
      { Header: "Sponser Id", accessor: "sponser_id" },
      //{ Header: "Wallet Address", accessor: "password" },
      { Header: "Package", accessor: "packageamount" },
      { Header: "Reg. Date & Time", accessor: "date_time" },
      { Header: "Activation Date & Time", accessor: "top_updates" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Active Member List</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        onChange={(e) => setSearch(e.target.value)}
                        ng-model="p.uid"
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter User Id"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setFromdate(e.target.value)}
                        value={formdate}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTodate(e.target.value)}
                        value={todate}
                        id="tdate"
                        name="tdate"
                        type="date"
                      />
                    </div>
                    {/* <div class="col-md-2">
                            <select
                              class="form-control in-ip-1"
                              id="Selectpackage"
                              value={Package}
                              onChange={(e) => setPackage(e.target.value)}
                              name="Selectpackage">
                              <option value="0">All Package</option>
                              <option value="30">$ 30</option>
                              <option value="100">$ 100</option>
                              <option value="500">$ 500</option>
                            </select>
                          </div> */}
                    <div class="col-md-2">
                      <input
                        type="reset"
                        id="btnsearch"
                        onClick={() => referral_API()}
                        class="btn btn-lg btn-primary"
                        value="Search"
                      />
                      &nbsp;&nbsp;
                    </div>
                    <div class="col-md-2">
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API_Export()}
                        class="btn btn-lg btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <h4>
                      <span>
                        Total Count: {TotalCount1}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total Amount:{" "}
                        {TotalAmount1}
                      </span>
                    </h4>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Active_Member;
